import { useQuery } from "react-query";
import { fetchDynamicMapData } from "./api";

export function useDynamicMap(filters, options={}) {
    return useQuery(["DynamicMapData", filters], () => fetchDynamicMapData(filters), {
      staleTime: 60000 * 60, 
      ...options
    })
  }